import {
  UPDATE_REMINDERS,
  UPDATE_REMINDERS_SUCCESS,
  UPDATE_REMINDERS_ERROR
} from "../actions/todos";

export default payload => (dispatch, getState) => {
  const {
    user: {
      data: { _id: user_id }
    }
  } = getState();

  dispatch({ type: UPDATE_REMINDERS, payload });
  return fetch(
    `${process.env.REACT_APP_USERDATA_URI}/update/reminders/${user_id}`,
    {
      method: "POST",
      body: JSON.stringify(payload)
    }
  )
    .then(res => res.json())
    .then(payload => dispatch({ type: UPDATE_REMINDERS_SUCCESS, payload }))
    .catch(({ message: payload }) =>
      dispatch({ type: UPDATE_REMINDERS_ERROR, payload })
    );
};



// WEBPACK FOOTER //
// ./src/store/epics/updateReminders.js